export interface VideoRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

const roundPixel = (value: number): number => (
  Math.abs(value) < 0.0005 ? 0 : Number(value.toFixed(3))
);

/** Return the centered picture bounds for a video element using object-fit: contain. */
export const getContainedVideoRect = (
  container: VideoRect,
  videoBox: VideoRect,
  intrinsicWidth: number,
  intrinsicHeight: number,
): VideoRect => {
  const box = {
    left: videoBox.left - container.left,
    top: videoBox.top - container.top,
    width: videoBox.width,
    height: videoBox.height,
  };
  if (
    box.width <= 0 || box.height <= 0
    || intrinsicWidth <= 0 || intrinsicHeight <= 0
  ) return box;

  const scale = Math.min(box.width / intrinsicWidth, box.height / intrinsicHeight);
  const width = intrinsicWidth * scale;
  const height = intrinsicHeight * scale;
  return {
    left: roundPixel(box.left + ((box.width - width) / 2)),
    top: roundPixel(box.top + ((box.height - height) / 2)),
    width: roundPixel(width),
    height: roundPixel(height),
  };
};

/** Keep caption text legible while adapting to the smaller dimension of the picture. */
export const getSubtitleCaptionFontSize = (pictureWidth: number, pictureHeight: number): number => {
  const size = Math.min(Math.max(1, pictureWidth), Math.max(1, pictureHeight));
  return roundPixel(Math.min(30, Math.max(18, size * 0.06)));
};
